import PropTypes from 'prop-types';
import { CircleAlert } from "lucide-react";


export default function ErrorMessage({errorMessage}) {

    return (
        errorMessage && (
            <div className="bg-red-200 text-red-600 p-4 flex flex-row items-center gap-3 mb-4" lang="fr"><CircleAlert size={24} />{errorMessage}</div>
        )
    )
}

ErrorMessage.propTypes = {
    errorMessage: PropTypes.string
};